import { render, staticRenderFns } from "./AppointmentsCalendar.vue?vue&type=template&id=58950c8e"
import script from "./AppointmentsCalendar.vue?vue&type=script&lang=js"
export * from "./AppointmentsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports